import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-photo-gallery',
  templateUrl: './photo-gallery.component.html',
  styleUrls: ['./photo-gallery.component.scss']
})
export class PhotoGalleryComponent implements OnInit {

  selectedLang: any;

  constructor(
    private translateService: TranslateService,
    private location: Location
  ) { }

  ngOnInit(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    // if (localStorage.getItem('lang')) {
    //   this.selectedLang = localStorage.getItem('lang') ? JSON.parse(localStorage.getItem('lang')) : ''
    //   this.translateService.use(this.selectedLang.code)
    // }
  }

  onChildValueChanged(value){
    // console.log(value)
    // if (value?.code == 'en') {
    //   // this.lanTranslate('en')
    // } else if (value?.code == 'hd') {
    //   // this.lanTranslate('hd')
    // }
  }

  goBack(): void {
    this.location.back();
  }

}
